/**
 * 운영 화면 → 운영 매뉴얼(`docs/manual/ops/`) 도움말 링크 정본.
 *
 * 형태는 Composer 에디터의 `pages/report-composer/manualLinks.ts`와 같다 — 어느 화면이 어느 문서로 가는지를 **여기 한 곳에만**
 * 두고, `__tests__/opsManualLinks.test.ts`가 대상 문서·앵커의 실재와 «화면 배선»(어느 화면이 그 키를 띄우나)을 잰다.
 * 경로 규약은 admin 라우트 `manual/:manual/:section/:slug`(App.tsx)와 같다.
 *
 * 소비는 `<OpsManualLink topic="…" />` 하나다(`components/OpsManualLink.tsx` — 새 탭으로 연다: 알림 설정처럼 입력 중인 화면에서
 * 같은 탭으로 가면 입력이 사라진다).
 */

export interface OpsManualLink {
  /** `/manual/ops/<섹션>/<slug>[#앵커]` */
  href: string;
  /** 링크 글 — title/aria-label에도 쓰인다 */
  label: string;
}

export const OPS_MANUAL_LINKS = {
  /** 운영 사건 목록·확인 처리 */
  incidentReview: {
    href: '/manual/ops/how-to/ops-incident-review',
    label: '운영 사건 확인하는 법',
  },
  /** 운영 사건 알림(내 채널·전역) 설정 */
  alertSettings: {
    href: '/manual/ops/how-to/ops-alert-settings',
    label: '알림 설정 안내',
  },
  /** 예약 작업 실행 기록 탭 */
  taskRuns: {
    href: '/manual/ops/how-to/ops-task-runs',
    label: '실행 기록 읽는 법',
  },
  /** 별표 복원의 「대응 안 된 기호」 확인 */
  annexUnmappedSymbols: {
    href: '/manual/ops/how-to/ops-annex-unmapped-symbols',
    label: '대응 안 된 기호 확인하는 법',
  },
} as const satisfies Record<string, OpsManualLink>;

export type OpsManualLinkKey = keyof typeof OPS_MANUAL_LINKS;
